/**
 * @fileoverview gRPC-Web generated client stub for occpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require('grpc-web');

var google_type_date_pb = require('../../google/type/date_pb.js');
const proto = {};
proto.occpb = require('./expired_position_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.occpb.OccExpiredPositionServiceClient = function (hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;
};

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.occpb.OccExpiredPositionServicePromiseClient = function (
  hostname,
  credentials,
  options
) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.occpb.ListExpiredPositionRequest,
 *   !proto.occpb.ListExpiredPositionResponse>}
 */
const methodDescriptor_OccExpiredPositionService_ListExpiredPosition =
  new grpc.web.MethodDescriptor(
    '/occpb.OccExpiredPositionService/ListExpiredPosition',
    grpc.web.MethodType.UNARY,
    proto.occpb.ListExpiredPositionRequest,
    proto.occpb.ListExpiredPositionResponse,
    /**
     * @param {!proto.occpb.ListExpiredPositionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.occpb.ListExpiredPositionResponse.deserializeBinary
  );

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.occpb.ListExpiredPositionRequest,
 *   !proto.occpb.ListExpiredPositionResponse>}
 */
const methodInfo_OccExpiredPositionService_ListExpiredPosition =
  new grpc.web.AbstractClientBase.MethodInfo(
    proto.occpb.ListExpiredPositionResponse,
    /**
     * @param {!proto.occpb.ListExpiredPositionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.occpb.ListExpiredPositionResponse.deserializeBinary
  );

/**
 * @param {!proto.occpb.ListExpiredPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.occpb.ListExpiredPositionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.occpb.ListExpiredPositionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.occpb.OccExpiredPositionServiceClient.prototype.listExpiredPosition = function (
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/occpb.OccExpiredPositionService/ListExpiredPosition',
    request,
    metadata || {},
    methodDescriptor_OccExpiredPositionService_ListExpiredPosition,
    callback
  );
};

/**
 * @param {!proto.occpb.ListExpiredPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.occpb.ListExpiredPositionResponse>}
 *     Promise that resolves to the response
 */
proto.occpb.OccExpiredPositionServicePromiseClient.prototype.listExpiredPosition =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ + '/occpb.OccExpiredPositionService/ListExpiredPosition',
      request,
      metadata || {},
      methodDescriptor_OccExpiredPositionService_ListExpiredPosition
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.occpb.ProcessExpiredPositionRequest,
 *   !proto.occpb.EmptyResponse>}
 */
const methodDescriptor_OccExpiredPositionService_ProcessExpiredPosition =
  new grpc.web.MethodDescriptor(
    '/occpb.OccExpiredPositionService/ProcessExpiredPosition',
    grpc.web.MethodType.UNARY,
    proto.occpb.ProcessExpiredPositionRequest,
    proto.occpb.EmptyResponse,
    /**
     * @param {!proto.occpb.ProcessExpiredPositionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.occpb.EmptyResponse.deserializeBinary
  );

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.occpb.ProcessExpiredPositionRequest,
 *   !proto.occpb.EmptyResponse>}
 */
const methodInfo_OccExpiredPositionService_ProcessExpiredPosition =
  new grpc.web.AbstractClientBase.MethodInfo(
    proto.occpb.EmptyResponse,
    /**
     * @param {!proto.occpb.ProcessExpiredPositionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.occpb.EmptyResponse.deserializeBinary
  );

/**
 * @param {!proto.occpb.ProcessExpiredPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.occpb.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.occpb.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.occpb.OccExpiredPositionServiceClient.prototype.processExpiredPosition = function (
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/occpb.OccExpiredPositionService/ProcessExpiredPosition',
    request,
    metadata || {},
    methodDescriptor_OccExpiredPositionService_ProcessExpiredPosition,
    callback
  );
};

/**
 * @param {!proto.occpb.ProcessExpiredPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.occpb.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.occpb.OccExpiredPositionServicePromiseClient.prototype.processExpiredPosition =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ + '/occpb.OccExpiredPositionService/ProcessExpiredPosition',
      request,
      metadata || {},
      methodDescriptor_OccExpiredPositionService_ProcessExpiredPosition
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.occpb.BatchProcessExpiredPositionRequest,
 *   !proto.occpb.BatchProcessExpiredPositionResponse>}
 */
const methodDescriptor_OccExpiredPositionService_BatchProcessExpiredPosition =
  new grpc.web.MethodDescriptor(
    '/occpb.OccExpiredPositionService/BatchProcessExpiredPosition',
    grpc.web.MethodType.UNARY,
    proto.occpb.BatchProcessExpiredPositionRequest,
    proto.occpb.BatchProcessExpiredPositionResponse,
    /**
     * @param {!proto.occpb.BatchProcessExpiredPositionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.occpb.BatchProcessExpiredPositionResponse.deserializeBinary
  );

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.occpb.BatchProcessExpiredPositionRequest,
 *   !proto.occpb.BatchProcessExpiredPositionResponse>}
 */
const methodInfo_OccExpiredPositionService_BatchProcessExpiredPosition =
  new grpc.web.AbstractClientBase.MethodInfo(
    proto.occpb.BatchProcessExpiredPositionResponse,
    /**
     * @param {!proto.occpb.BatchProcessExpiredPositionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.occpb.BatchProcessExpiredPositionResponse.deserializeBinary
  );

/**
 * @param {!proto.occpb.BatchProcessExpiredPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.occpb.BatchProcessExpiredPositionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.occpb.BatchProcessExpiredPositionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.occpb.OccExpiredPositionServiceClient.prototype.batchProcessExpiredPosition =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ + '/occpb.OccExpiredPositionService/BatchProcessExpiredPosition',
      request,
      metadata || {},
      methodDescriptor_OccExpiredPositionService_BatchProcessExpiredPosition,
      callback
    );
  };

/**
 * @param {!proto.occpb.BatchProcessExpiredPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.occpb.BatchProcessExpiredPositionResponse>}
 *     Promise that resolves to the response
 */
proto.occpb.OccExpiredPositionServicePromiseClient.prototype.batchProcessExpiredPosition =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ + '/occpb.OccExpiredPositionService/BatchProcessExpiredPosition',
      request,
      metadata || {},
      methodDescriptor_OccExpiredPositionService_BatchProcessExpiredPosition
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.occpb.UpdateExpiredPositionRequest,
 *   !proto.occpb.UpdateExpiredPositionResponse>}
 */
const methodDescriptor_OccExpiredPositionService_UpdateExpiredPosition =
  new grpc.web.MethodDescriptor(
    '/occpb.OccExpiredPositionService/UpdateExpiredPosition',
    grpc.web.MethodType.UNARY,
    proto.occpb.UpdateExpiredPositionRequest,
    proto.occpb.UpdateExpiredPositionResponse,
    /**
     * @param {!proto.occpb.UpdateExpiredPositionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.occpb.UpdateExpiredPositionResponse.deserializeBinary
  );

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.occpb.UpdateExpiredPositionRequest,
 *   !proto.occpb.UpdateExpiredPositionResponse>}
 */
const methodInfo_OccExpiredPositionService_UpdateExpiredPosition =
  new grpc.web.AbstractClientBase.MethodInfo(
    proto.occpb.UpdateExpiredPositionResponse,
    /**
     * @param {!proto.occpb.UpdateExpiredPositionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.occpb.UpdateExpiredPositionResponse.deserializeBinary
  );

/**
 * @param {!proto.occpb.UpdateExpiredPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.occpb.UpdateExpiredPositionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.occpb.UpdateExpiredPositionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.occpb.OccExpiredPositionServiceClient.prototype.updateExpiredPosition = function (
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/occpb.OccExpiredPositionService/UpdateExpiredPosition',
    request,
    metadata || {},
    methodDescriptor_OccExpiredPositionService_UpdateExpiredPosition,
    callback
  );
};

/**
 * @param {!proto.occpb.UpdateExpiredPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.occpb.UpdateExpiredPositionResponse>}
 *     Promise that resolves to the response
 */
proto.occpb.OccExpiredPositionServicePromiseClient.prototype.updateExpiredPosition =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ + '/occpb.OccExpiredPositionService/UpdateExpiredPosition',
      request,
      metadata || {},
      methodDescriptor_OccExpiredPositionService_UpdateExpiredPosition
    );
  };

module.exports = proto.occpb;
